export default __webpack_public_path__ + "static/media/img3.95772abd.png";